import { useContext } from 'react';
import { LanguageContext } from '../contexts/LanguageContext';
import en from '../translations/en';
import hu from '../translations/hu';

const translations = { en, hu };

const languages = [
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'hu', name: 'Magyar', flag: '🇭🇺' },
];

const defaultLanguage = 'en';

export function useTranslation() {
  const { language, setLanguage } = useContext(LanguageContext);
  
  const t = (key) => {
    const keys = key.split('.');
    let value = translations[language];
    
    for (const k of keys) {
      value = value?.[k];
    }
    
    return value || key;
  };
  
  const i18n = {
    language,
    changeLanguage: setLanguage
  };

  return {
    t,
    i18n,
    languages,
    defaultLanguage,
  };
} 